<template>
  <div
    :class="sizeClass"
    class="flex items-center justify-center bg-grey-light rounded-full pt-avatar"
  >
    <i
      v-if="type === 'icon'"
      :class="iconClass"
      :style="iconSize"
      class="text-grey fa"
    />
    <img
      v-if="type === 'image'"
      :src="src"
      style="width: 100%; height: 100%;"
      class="rounded-full"
    >
  </div>
</template>

<script>
export default {
  name: 'PtAvatar',
  props: {
    size: {
      type: String,
      default: null,
    },
    editable: {
      type: Boolean,
      default: false,
    },
    iconClass: {
      type: String,
      default: 'fa-user',
    },
    src: {
      type: String,
      default: null,
    },
    type: {
      type: String,
      default: 'icon',
    },
  },
  computed: {
    sizeClass() {
      // Regular
      if (!this.size) {
        return `w-32 h-32`;
      }

      // Nano
      if (this.size.toLowerCase() === 'nn') {
        return `w-8 h-8`;
      }

      // Extra Small
      if (this.size.toLowerCase() === 'xs') {
        return `w-16 h-16`;
      }

      // Small
      if (this.size.toLowerCase() === 'sm') {
        return `w-24 h-24`;
      }

      // Large
      if (this.size.toLowerCase() === 'lg') {
        return `w-48 h-48`;
      }

      // Extra Large
      if (this.size.toLowerCase() === 'xl') {
        return `w-64 h-64`;
      }

      return `w-32 h-32`;
    },
    iconSize() {
      let fontSize = 100;

      if (this.size) {
        if (this.size.toLowerCase() === 'nn') {
          fontSize = 20;
        }

        if (this.size.toLowerCase() === 'xs') {
          fontSize = 50;
        }

        if (this.size.toLowerCase() === 'sm') {
          fontSize = 60;
        }

        if (this.size.toLowerCase() === 'lg') {
          fontSize = 150;
        }

        if (this.size.toLowerCase() === 'xl') {
          fontSize = 230;
        }
      }

      return {
        fontSize: `${fontSize}px`,
      };
    },
  },
};
</script>
